import { Component, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'app-update-notification',
  template: `
    <div *ngIf="showUpdate" class="update-banner">
      <ion-icon name="sparkles"></ion-icon>
      <ion-label>Nueva versión disponible</ion-label>
      <ion-button (click)="activateUpdate()" color="light">
        Actualizar
      </ion-button>
      <ion-button fill="clear" (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </div>
  `,
  styles: [`
    .update-banner {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      background: var(--ion-color-primary);
      color: white;
      padding: 8px 16px;
      display: flex;
      align-items: center;
      gap: 8px;
      z-index: 9999;
      font-size: 14px;
    }
  `]
})
export class UpdateNotificationComponent implements OnInit {
  showUpdate = false;

  constructor(private swUpdate: SwUpdate) {}

  ngOnInit() {
    // Mostrar notificación si hay actualización disponible
    this.swUpdate.versionUpdates.subscribe((event) => {
      this.showUpdate = true;
    });
  }

  async activateUpdate() {
    try {
      const updated = await this.swUpdate.activateUpdate();
      // Recargar la página para aplicar la actualización
      window.location.reload();
    } catch (err) {
      console.error('Failed to activate update:', err);
    }
  }

  dismiss() {
    this.showUpdate = false;
    localStorage.setItem('update-dismissed', 'true');
  }
}
